import { updateKeyInStore } from 'App';
import { countries } from 'countries';
import * as Yup from 'yup';
import { updateKey, UsTrustStateValues } from './slice';

// predicate:
// 'Displayed in case the user selects "Yes" to the "I have a US Trust" question in the general tab.',

export const fields: IBaseField<keyof UsTrustStateValues>[] = [
  {
    name: 'nameOfTrust',
    label: 'Name of trust',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Enter...',
  },
  {
    name: 'streetAddress',
    label: 'Street Address',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Enter...',
  },
  {
    name: 'city',
    label: 'City',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Enter...',
  },
  {
    name: 'stateOrProvince',
    label: 'State or Province',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Enter...',
  },
  {
    name: 'postCode',
    label: 'Post Code',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Enter...',
  },

  {
    name: 'country',
    label: 'Country',
    type: 'country',
    placeholder: 'Select Country',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'dateOfCreation',
    label: 'Date of Creation',
    subLabel: () => (
      <p>
        A trust deed document will have the date when the trust was created.
      </p>
    ),
    type: 'date',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Select Date',
  },
  {
    name: 'endOfTaxYear',
    label: 'End of Tax Year',
    subLabel: () => (
      <p>
        A calendar year ends Dec 31st whereas the fiscal year begins on the day
        of the individual's death and ends on the last day of the month prior to
        the one year death anniversary.Fiscal year elections are available only
        to estates. Trusts are generally required to filed according to the
        calendar year.
      </p>
    ),
    type: 'date',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Select Date',
  },

  {
    name: 'countryOfIncorporation',
    label: 'Country of Incorporation',
    type: 'country',
    placeholder: 'Select Country',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'pleaseUploadTrustFinancial',
    label: 'Please upload Trust Financial',
    subLabel: () => (
      <p>
        If a US trust and estate form is already filled, please attach sch K-1
      </p>
    ),
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
];

export const validationSchema = Yup.object().shape({});
